import { Injectable, OnInit } from '@angular/core';

@Injectable()
export class AppConfig {
    dateFormatJS: string = "yyyy-MM-dd";
    timeFormatJS: string = "hh:mm:ss";
    dateTimeFormatJS: string = "yyyy-MM-dd hh:mm";

    dateFormat: string = "YYYY-MM-DD";
    timeFormat: string = "HH:mm:ss";
    timeFormatExamCards: string = "HH:mm";
    dateTimeFormat: string = "YYYY-MM-DD HH:mm";

    static phoneNumberRegEx = "[()+0-9-xX ]+"; // Allowed Chars ( ) + 0-9 - x X
    static certificateIDRegEx = "[0-9a-zA-Z-\\-]+"; // Allowed Chars 0-9 a-z A-Z
    static domainRegEx = /^[a-zA-Z0-9.-]+$/; // Allowded Chars 0 - 9 * a to z and -, .
    static macAddressRegEx = '[0-9a-fA-F:]+';
    static onlyNumericRegEx = "[0-9]+"; // Allowed Chars 0-9 a-z A-Z
    static emailPattern = "^[_A-Za-z0-9-\\+]+(\\.[_A-Za-z0-9-\\+]+)*@" + "[A-Za-z0-9-]+(\\.[A-Za-z0-9]+)*(\\.[A-Za-z]{2,})$";

    constructor() {

    }
}


// WEBPACK FOOTER //
// /opt/app-root/src/src/app/Common/appConfiguration.ts